<formstep-detail :options="options" :editable="false" :model="model"></formstep-detail>